/*undefined*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.DebtorListFilter = (function() {

    /**
     * Namespace DebtorListFilter.
     * @exports DebtorListFilter
     * @namespace
     */
    var DebtorListFilter = {};

    DebtorListFilter.DebtorListFilterModel = (function() {

        /**
         * Properties of a DebtorListFilterModel.
         * @memberof DebtorListFilter
         * @interface IDebtorListFilterModel
         * @property {string|null} [invoiceNo] DebtorListFilterModel invoiceNo
         * @property {string|null} [debtorName] DebtorListFilterModel debtorName
         * @property {string|null} [quoteNo] DebtorListFilterModel quoteNo
         * @property {string|null} [dateFrom] DebtorListFilterModel dateFrom
         * @property {string|null} [dateTo] DebtorListFilterModel dateTo
         * @property {number|null} [filterType] DebtorListFilterModel filterType
         * @property {string|null} [sortColumn] DebtorListFilterModel sortColumn
         * @property {string|null} [sortOrder] DebtorListFilterModel sortOrder
         * @property {number|null} [pageIndex] DebtorListFilterModel pageIndex
         * @property {number|null} [pageSize] DebtorListFilterModel pageSize
         * @property {string|null} [exported] DebtorListFilterModel exported
         */

        /**
         * Constructs a new DebtorListFilterModel.
         * @memberof DebtorListFilter
         * @classdesc Represents a DebtorListFilterModel.
         * @implements IDebtorListFilterModel
         * @constructor
         * @param {DebtorListFilter.IDebtorListFilterModel=} [p] Properties to set
         */
        function DebtorListFilterModel(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * DebtorListFilterModel invoiceNo.
         * @member {string|null|undefined} invoiceNo
         * @memberof DebtorListFilter.DebtorListFilterModel
         * @instance
         */
        DebtorListFilterModel.prototype.invoiceNo = null;

        /**
         * DebtorListFilterModel debtorName.
         * @member {string|null|undefined} debtorName
         * @memberof DebtorListFilter.DebtorListFilterModel
         * @instance
         */
        DebtorListFilterModel.prototype.debtorName = null;

        /**
         * DebtorListFilterModel quoteNo.
         * @member {string|null|undefined} quoteNo
         * @memberof DebtorListFilter.DebtorListFilterModel
         * @instance
         */
        DebtorListFilterModel.prototype.quoteNo = null;

        /**
         * DebtorListFilterModel dateFrom.
         * @member {string|null|undefined} dateFrom
         * @memberof DebtorListFilter.DebtorListFilterModel
         * @instance
         */
        DebtorListFilterModel.prototype.dateFrom = null;

        /**
         * DebtorListFilterModel dateTo.
         * @member {string|null|undefined} dateTo
         * @memberof DebtorListFilter.DebtorListFilterModel
         * @instance
         */
        DebtorListFilterModel.prototype.dateTo = null;

        /**
         * DebtorListFilterModel filterType.
         * @member {number|null|undefined} filterType
         * @memberof DebtorListFilter.DebtorListFilterModel
         * @instance
         */
        DebtorListFilterModel.prototype.filterType = null;

        /**
         * DebtorListFilterModel sortColumn.
         * @member {string|null|undefined} sortColumn
         * @memberof DebtorListFilter.DebtorListFilterModel
         * @instance
         */
        DebtorListFilterModel.prototype.sortColumn = null;

        /**
         * DebtorListFilterModel sortOrder.
         * @member {string|null|undefined} sortOrder
         * @memberof DebtorListFilter.DebtorListFilterModel
         * @instance
         */
        DebtorListFilterModel.prototype.sortOrder = null;

        /**
         * DebtorListFilterModel pageIndex.
         * @member {number|null|undefined} pageIndex
         * @memberof DebtorListFilter.DebtorListFilterModel
         * @instance
         */
        DebtorListFilterModel.prototype.pageIndex = null;

        /**
         * DebtorListFilterModel pageSize.
         * @member {number|null|undefined} pageSize
         * @memberof DebtorListFilter.DebtorListFilterModel
         * @instance
         */
        DebtorListFilterModel.prototype.pageSize = null;

        /**
         * DebtorListFilterModel exported.
         * @member {string|null|undefined} exported
         * @memberof DebtorListFilter.DebtorListFilterModel
         * @instance
         */
        DebtorListFilterModel.prototype.exported = null;

        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;

        /**
         * DebtorListFilterModel _invoiceNo.
         * @member {"invoiceNo"|undefined} _invoiceNo
         * @memberof DebtorListFilter.DebtorListFilterModel
         * @instance
         */
        Object.defineProperty(DebtorListFilterModel.prototype, "_invoiceNo", {
            get: $util.oneOfGetter($oneOfFields = ["invoiceNo"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * DebtorListFilterModel _debtorName.
         * @member {"debtorName"|undefined} _debtorName
         * @memberof DebtorListFilter.DebtorListFilterModel
         * @instance
         */
        Object.defineProperty(DebtorListFilterModel.prototype, "_debtorName", {
            get: $util.oneOfGetter($oneOfFields = ["debtorName"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * DebtorListFilterModel _quoteNo.
         * @member {"quoteNo"|undefined} _quoteNo
         * @memberof DebtorListFilter.DebtorListFilterModel
         * @instance
         */
        Object.defineProperty(DebtorListFilterModel.prototype, "_quoteNo", {
            get: $util.oneOfGetter($oneOfFields = ["quoteNo"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * DebtorListFilterModel _dateFrom.
         * @member {"dateFrom"|undefined} _dateFrom
         * @memberof DebtorListFilter.DebtorListFilterModel
         * @instance
         */
        Object.defineProperty(DebtorListFilterModel.prototype, "_dateFrom", {
            get: $util.oneOfGetter($oneOfFields = ["dateFrom"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * DebtorListFilterModel _dateTo.
         * @member {"dateTo"|undefined} _dateTo
         * @memberof DebtorListFilter.DebtorListFilterModel
         * @instance
         */
        Object.defineProperty(DebtorListFilterModel.prototype, "_dateTo", {
            get: $util.oneOfGetter($oneOfFields = ["dateTo"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * DebtorListFilterModel _filterType.
         * @member {"filterType"|undefined} _filterType
         * @memberof DebtorListFilter.DebtorListFilterModel
         * @instance
         */
        Object.defineProperty(DebtorListFilterModel.prototype, "_filterType", {
            get: $util.oneOfGetter($oneOfFields = ["filterType"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * DebtorListFilterModel _sortColumn.
         * @member {"sortColumn"|undefined} _sortColumn
         * @memberof DebtorListFilter.DebtorListFilterModel
         * @instance
         */
        Object.defineProperty(DebtorListFilterModel.prototype, "_sortColumn", {
            get: $util.oneOfGetter($oneOfFields = ["sortColumn"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * DebtorListFilterModel _sortOrder.
         * @member {"sortOrder"|undefined} _sortOrder
         * @memberof DebtorListFilter.DebtorListFilterModel
         * @instance
         */
        Object.defineProperty(DebtorListFilterModel.prototype, "_sortOrder", {
            get: $util.oneOfGetter($oneOfFields = ["sortOrder"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * DebtorListFilterModel _pageIndex.
         * @member {"pageIndex"|undefined} _pageIndex
         * @memberof DebtorListFilter.DebtorListFilterModel
         * @instance
         */
        Object.defineProperty(DebtorListFilterModel.prototype, "_pageIndex", {
            get: $util.oneOfGetter($oneOfFields = ["pageIndex"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * DebtorListFilterModel _pageSize.
         * @member {"pageSize"|undefined} _pageSize
         * @memberof DebtorListFilter.DebtorListFilterModel
         * @instance
         */
        Object.defineProperty(DebtorListFilterModel.prototype, "_pageSize", {
            get: $util.oneOfGetter($oneOfFields = ["pageSize"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * DebtorListFilterModel _exported.
         * @member {"exported"|undefined} _exported
         * @memberof DebtorListFilter.DebtorListFilterModel
         * @instance
         */
        Object.defineProperty(DebtorListFilterModel.prototype, "_exported", {
            get: $util.oneOfGetter($oneOfFields = ["exported"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Encodes the specified DebtorListFilterModel message. Does not implicitly {@link DebtorListFilter.DebtorListFilterModel.verify|verify} messages.
         * @function encode
         * @memberof DebtorListFilter.DebtorListFilterModel
         * @static
         * @param {DebtorListFilter.IDebtorListFilterModel} m DebtorListFilterModel message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DebtorListFilterModel.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.invoiceNo != null && Object.hasOwnProperty.call(m, "invoiceNo"))
                w.uint32(10).string(m.invoiceNo);
            if (m.debtorName != null && Object.hasOwnProperty.call(m, "debtorName"))
                w.uint32(18).string(m.debtorName);
            if (m.quoteNo != null && Object.hasOwnProperty.call(m, "quoteNo"))
                w.uint32(26).string(m.quoteNo);
            if (m.dateFrom != null && Object.hasOwnProperty.call(m, "dateFrom"))
                w.uint32(34).string(m.dateFrom);
            if (m.dateTo != null && Object.hasOwnProperty.call(m, "dateTo"))
                w.uint32(42).string(m.dateTo);
            if (m.filterType != null && Object.hasOwnProperty.call(m, "filterType"))
                w.uint32(48).int32(m.filterType);
            if (m.sortColumn != null && Object.hasOwnProperty.call(m, "sortColumn"))
                w.uint32(58).string(m.sortColumn);
            if (m.sortOrder != null && Object.hasOwnProperty.call(m, "sortOrder"))
                w.uint32(66).string(m.sortOrder);
            if (m.pageIndex != null && Object.hasOwnProperty.call(m, "pageIndex"))
                w.uint32(72).int32(m.pageIndex);
            if (m.pageSize != null && Object.hasOwnProperty.call(m, "pageSize"))
                w.uint32(80).int32(m.pageSize);
            if (m.exported != null && Object.hasOwnProperty.call(m, "exported"))
                w.uint32(90).string(m.exported);
            return w;
        };

        /**
         * Encodes the specified DebtorListFilterModel message, length delimited. Does not implicitly {@link DebtorListFilter.DebtorListFilterModel.verify|verify} messages.
         * @function encodeDelimited
         * @memberof DebtorListFilter.DebtorListFilterModel
         * @static
         * @param {DebtorListFilter.IDebtorListFilterModel} message DebtorListFilterModel message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DebtorListFilterModel.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DebtorListFilterModel message from the specified reader or buffer.
         * @function decode
         * @memberof DebtorListFilter.DebtorListFilterModel
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {DebtorListFilter.DebtorListFilterModel} DebtorListFilterModel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DebtorListFilterModel.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.DebtorListFilter.DebtorListFilterModel();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.invoiceNo = r.string();
                    break;
                case 2:
                    m.debtorName = r.string();
                    break;
                case 3:
                    m.quoteNo = r.string();
                    break;
                case 4:
                    m.dateFrom = r.string();
                    break;
                case 5:
                    m.dateTo = r.string();
                    break;
                case 6:
                    m.filterType = r.int32();
                    break;
                case 7:
                    m.sortColumn = r.string();
                    break;
                case 8:
                    m.sortOrder = r.string();
                    break;
                case 9:
                    m.pageIndex = r.int32();
                    break;
                case 10:
                    m.pageSize = r.int32();
                    break;
                case 11:
                    m.exported = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * Decodes a DebtorListFilterModel message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof DebtorListFilter.DebtorListFilterModel
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {DebtorListFilter.DebtorListFilterModel} DebtorListFilterModel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DebtorListFilterModel.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        return DebtorListFilterModel;
    })();

    return DebtorListFilter;
})();

module.exports = $root;
